import { render, staticRenderFns } from "./InsertCode.vue?vue&type=template&id=5340b5a2&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "@/scss/login.scss?vue&type=style&index=0&id=5340b5a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5340b5a2",
  null
  
)

export default component.exports